import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/projects/properties/page.tsx");
